import React, { useEffect } from 'react';

const IconMail = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><rect x="3" y="5" width="18" height="14" rx="1"/><path d="m3 7 9 6 9-6"/></svg>
);
const IconLinkedIn = () => (
  <svg viewBox="0 0 24 24" fill="currentColor"><path d="M4.98 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zM3 9h4v12H3zM9 9h3.8v1.7h.05c.53-.95 1.83-1.95 3.77-1.95C20.4 8.75 21 11 21 14.1V21h-4v-6.1c0-1.45-.03-3.3-2.02-3.3-2.02 0-2.33 1.57-2.33 3.2V21H9z"/></svg>
);
const IconArrow = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><path d="M7 17 17 7M9 7h8v8"/></svg>
);
const IconPlay = () => (
  <svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>
);

const ventures = [
  {
    n: '01', name: 'ShakeDeal', role: 'Founder & MD', years: '2016 — Present',
    desc: 'Shakedeal is a B2B commerce and procurement enablement platform trusted by over 300+ enterprise clients, helping them drive 5-8% efficiency gains across sourcing, fulfillment, and commercial operations.',
    pillars: [
      { t: 'B2B E-commerce Infrastructure', d: 'Building custom procurement portals and digital catalogs that simplify sourcing, fulfillment, and vendor management for large organizations.' },
      { t: 'AI-Enabled Procurement Automation', d: 'Helping enterprises digitize and optimize purchase workflows — from PR-to-PO — using data-driven decisioning and automation.' },
      { t: 'Tail Spend Management', d: 'Centralizing and streamlining long-tail procurement to reduce maverick spend and improve compliance across indirect categories.' },
    ],
  },
  {
    n: '02', name: 'ShakePe', role: 'Co-Founder', years: '2022 — Present',
    desc: 'ShakePe is an enterprise-grade rewards and recognition platform that helps businesses deliver impactful employee and channel incentives.',
    pillars: [
      { t: 'Enterprise Rewards & Milestone Gifting', d: 'A flexible platform to manage employee rewards, achievement-based recognition, and special occasion gifting at scale.' },
      { t: 'Channel Incentivization', d: 'Drive partner engagement with personalized reward campaigns delivered through WhatsApp, email, or direct links.' },
      { t: 'Redemption Marketplace', d: 'Recipients can redeem rewards from a vast catalog of products, experiences, and vouchers — all tracked and managed in real-time.' },
    ],
  },
  {
    n: '03', name: 'Aegon Power', role: 'Founder', years: '2018 — Present',
    desc: "Aegon Power is a private label brand offering high-performance power tools and equipment for India's growing D2C and B2B markets.",
    pillars: [
      { t: 'D2C E-commerce Brand Building', d: 'Scaled a direct-to-consumer brand delivering durable, cost-effective tools to end users across India through digital-first channels.' },
      { t: 'Category Leadership in Tools & Equipment', d: 'Built a portfolio of best-selling products across agricultural tools, construction equipment, and professional-grade power tools.' },
    ],
  },
  {
    n: '04', name: 'Shipway', role: 'Angel Investor', years: '2021 — Present',
    desc: "As India's second-largest shipping aggregator, Shipway enables D2C and enterprise brands to streamline fulfillment, automate tracking, and scale their post-order operations with confidence. Recently acquired by Unicommerce.",
    pillars: [
      { t: 'Shipping Aggregation & Fulfillment Automation', d: 'Providing a unified interface to access multiple courier partners, automate order fulfillment, and optimize shipping decisions at scale.' },
      { t: 'Post-Purchase Customer Experience', d: 'Enabling real-time tracking, branded notifications, and proactive communication to reduce delivery anxiety and improve customer retention.' },
      { t: 'Returns & RTO Management', d: 'Offering advanced tools to reduce Return-to-Origin (RTO) rates, streamline reverse logistics, and protect margins for e-commerce businesses.' },
    ],
  },
];

const talks = [
  { kick: 'StartUp Summit 2019', title: 'Taking a company from Seed to Series A', date: 'June 2019', loc: 'Bangalore, India', desc: 'Discussing How to Scale with some of the best minds of the ecosystem', img: '/startup-summit-2019.jpeg' },
  { kick: '13th Express, Logistics & Supply Chain Conclave', title: 'How procurement is no longer about focusing on cost savings only', date: 'Nov 2019', loc: "Taj Land's End, Mumbai", desc: 'Discussion with industry experts from various sectors on how procurement is no longer about focusing on cost savings only, and how does one manage to build long term relationships with suppliers while shifting focus beyond the cost', img: '/express-logistics-supply-chain.jpeg' },
  { kick: 'Digital Bharat Economy Enclave · Financial Express', title: 'Unlocking growth for small and medium businesses through digital transformation', date: 'March 2024', loc: 'The Lalit, New Delhi', desc: 'Deep dive into the question of whether government-backed digital initiatives like ONDC, GEM, TReDS, OCEN, etc., can drive the adoption of digital technologies within SMEs', img: '/digital-bharat-economy-enclave.jpeg' },
  { kick: 'NXTGEN ProcureConnect 2024 · Delhi Chapter', title: 'Digital Transformation AI Solutions to Address Common Pain Points in Supply Chain and Procurement', date: 'July 2024', loc: 'Sheraton, New Delhi', desc: 'Shared valuable insights on current global supply chain issues and showcased how AI is transforming enterprise commerce through innovations and intelligence.', img: '/ProcureConnect.jpg' },
];

const press = [
  { outlet: 'Forbes Asia', title: 'Forbes 30 Under 30 Asia 2021 — Retail & Ecommerce', quote: '"More than 10,000 companies have become clients of the Bangalore-based B2B platform for office supplies and industrial goods since the Hegde brothers founded it in 2016."', img: 'https://imageio.forbes.com/specials-images/imageserve/607708432e610417a0aa612a/0x0.jpg?format=jpg&crop=1080,1080,x0,y0,safe&height=416&width=416&fit=bounds', url: 'https://www.forbes.com/30-under-30/2021/asia/retail-ecommerce?profile=shakedeal' },
  { outlet: 'Financial Express', title: 'Simplifying P2P', quote: '"Integration of B2B marketplaces into supply chain networks for increased efficiency"', img: 'https://www.financialexpress.com/wp-content/uploads/2023/08/logistics.jpg?w=1024', url: 'https://www.financialexpress.com/business/industry-integration-of-b2b-marketplaces-into-supply-chain-networks-for-increased-efficiency-3224744/' },
  { outlet: 'Entrepreneur.com', title: 'Procurement Partners', quote: '"In 2016, brothers Akshay and Akash Hegde & Santhosh Reddy came up with the idea of ShakeDeal – a B2B ecommerce platform that solves problems in the procurement and distribution space"', img: 'https://assets.entrepreneur.com/content/3x2/2000/1613392515-MyPost36.jpg?format=pjeg&auto=webp&crop=16:9&width=675&height=380', url: 'https://www.entrepreneur.com/en-in/news-and-trends/procurement-partners/365404' },
];

const awards = [
  { t: 'Forbes 30 Under 30 Asia', y: 'Class of 2021' },
  { t: 'Entrepreneur 35 under 35', y: 'Class of 2021' },
  { t: 'E-Commerce Startup of the Year', y: '2020' },
  { t: 'CNBC Young Turks', y: '2021' },
  { t: 'Fastest Growing Small Business', y: '2020' },
];

const PODCAST_URL = 'https://www.youtube.com/watch?v=8slHmiv2LOI';

function App() {
  useEffect(() => {
    const els = document.querySelectorAll('.reveal');
    const reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    let io;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach((e) => e.classList.add('in'));
    } else {
      io = new IntersectionObserver((entries) => {
        entries.forEach((x) => { if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); } });
      }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
      els.forEach((e) => io.observe(e));
    }

    let spy;
    if ('IntersectionObserver' in window) {
      const navlinks = document.querySelectorAll('.index-nav a');
      spy = new IntersectionObserver((entries) => {
        entries.forEach((x) => {
          if (x.isIntersecting) {
            navlinks.forEach((a) => a.classList.toggle('active', a.getAttribute('href') === '#' + x.target.id));
          }
        });
      }, { rootMargin: '-40% 0px -55% 0px' });
      document.querySelectorAll('main .block').forEach((s) => { if (s.id) spy.observe(s); });
    }

    return () => { if (io) io.disconnect(); if (spy) spy.disconnect(); };
  }, []);

  const year = new Date().getFullYear();

  return (
    <div className="shell">
      <a className="skip" href="#content">Skip to content</a>

      <aside className="panel">
        <div className="panel-top">
          <span className="monogram">AH</span>
          <span className="label">Bangalore · Est. 2016</span>
        </div>
        <div className="panel-mid">
          <h1 className="nameplate">Akshay<br />Hegde</h1>
          <span className="role-tag">Builder <i></i> Operator <i></i> Investor</span>
          <figure className="portrait">
            <img src="/Profile Photo.JPG" alt="Akshay Hegde, Founder and Managing Director of ShakeDeal" width="212" height="258" />
          </figure>
          <p className="panel-desc">Co-founder of ShakeDeal and the fintech ShakePe, applying AI-first thinking to B2B commerce, procurement and rewards.</p>
        </div>
        <div className="panel-bottom">
          <nav aria-label="Sections">
            <ul className="index-nav">
              <li><a href="#about"><span className="n">01</span><span className="t">About</span></a></li>
              <li><a href="#ventures"><span className="n">02</span><span className="t">Ventures</span></a></li>
              <li><a href="#voice"><span className="n">03</span><span className="t">Speaking</span></a></li>
              <li><a href="#podcast"><span className="n">04</span><span className="t">Podcast</span></a></li>
              <li><a href="#press"><span className="n">05</span><span className="t">Press</span></a></li>
              <li><a href="#recognition"><span className="n">06</span><span className="t">Recognition</span></a></li>
            </ul>
          </nav>
          <div className="panel-contact">
            <a href="mailto:akshay.0015@gmail.com"><IconMail />Email</a>
            <a href="https://www.linkedin.com/in/akshay7hegde/" target="_blank" rel="noreferrer"><IconLinkedIn />LinkedIn</a>
          </div>
        </div>
      </aside>

      <main className="content" id="content">

        <section className="block" id="about">
          <p className="block-label label">01 — About</p>
          <p className="lead reveal">Builder at heart, strategist by craft.</p>
          <div className="prose reveal">
            <p>I'm Akshay Hegde — a builder at heart and a strategist by craft. As the co-founder of Shakedeal and fintech - ShakePe, I've spent the last several years transforming how enterprises approach procurement, rewards, and e-commerce.</p>
            <p>I specialize in applying AI-first thinking to B2B challenges — from building autonomous procurement workflows to designing scalable platforms for procurement, employee recognition and enterprise gifting.</p>
            <p>I'm also an active angel investor with an eye for disruptive startups. A recent highlight — a company I backed was acquired by Unicommerce and is now the second-largest shipping aggregator in India. Supporting founders on their journey to scale is something I care deeply about.</p>
            <p>If you're working on the future of AI, enterprise tech, or B2B innovation — let's connect.</p>
          </div>
        </section>

        <section className="block" id="ventures">
          <p className="block-label label">02 — Building the future</p>
          <ol className="vindex reveal">
            {ventures.map((v) => (
              <li className="vitem" key={v.name}>
                <div className="vitem-head">
                  <span className="vnum">{v.n}</span>
                  <div><h3>{v.name}</h3><span className="role">{v.role}</span></div>
                  <span className="vyr">{v.years}</span>
                </div>
                <p className="vdesc">{v.desc}</p>
                <dl className="vpillars">
                  {v.pillars.map((p) => (
                    <div key={p.t}><dt>{p.t}</dt><dd>{p.d}</dd></div>
                  ))}
                </dl>
              </li>
            ))}
          </ol>
        </section>

        <section className="block" id="voice">
          <p className="block-label label">03 — Where I've shared my voice</p>
          <ul className="talks reveal">
            {talks.map((t) => (
              <li className="talk" key={t.title}>
                <figure className="thumb"><img src={t.img} alt={`${t.title} — ${t.kick}`} width="640" height="440" loading="lazy" /></figure>
                <div>
                  <span className="kick">{t.kick}</span>
                  <h3>{t.title}</h3>
                  <div className="meta"><span>{t.date}</span><span>{t.loc}</span></div>
                  <p>{t.desc}</p>
                </div>
              </li>
            ))}
          </ul>
          <div className="linkline reveal">
            <p className="note">Interested in having me speak at your next event? I share insights on B2B innovation, procurement transformation, and entrepreneurship.</p>
            <a className="link-cta" href="mailto:akshay@shakedeal.com?subject=Speaking Inquiry">Invite Me to Speak</a>
          </div>
        </section>

        <section className="block" id="podcast">
          <p className="block-label label">04 — Podcast appearances</p>
          <div className="podcast reveal">
            <figure className="fig">
              <img src="/podcast-thumb-founder-talk.png" alt="How to Build a Multi Crore B2B Tech Business in 10 Years" width="1280" height="720" />
              <a className="play" href={PODCAST_URL} target="_blank" rel="noreferrer" aria-label="Watch on YouTube"><span><IconPlay /></span></a>
            </figure>
            <div>
              <h3>How to Build a Multi Crore B2B Tech Business in 10 Years?</h3>
              <p>10 years. 200+ enterprise clients. Tata, Adani, Siemens, Vedanta. A long-form conversation on building ShakeDeal from scratch, scaling B2B procurement tech, and lessons from a decade in the trenches.</p>
              <a className="link-cta" href={PODCAST_URL} target="_blank" rel="noreferrer">Watch on YouTube <IconArrow /></a>
            </div>
          </div>
        </section>

        <section className="block" id="press">
          <p className="block-label label">05 — Media &amp; press coverage</p>
          <ul className="press reveal">
            {press.map((p) => (
              <li className="pitem" key={p.outlet}>
                <figure className="thumb"><img src={p.img} alt={`${p.outlet} — ${p.title}`} width="600" height="450" loading="lazy" /></figure>
                <div>
                  <span className="outlet">{p.outlet}</span>
                  <h3>{p.title}</h3>
                  <p className="quote">{p.quote}</p>
                </div>
                <a className="go" href={p.url} target="_blank" rel="noreferrer">Read →</a>
              </li>
            ))}
          </ul>
          <div className="linkline reveal">
            <a className="link-cta" href="https://stories.shakedeal.com/news/" target="_blank" rel="noreferrer">View All Media Coverage <IconArrow /></a>
          </div>
        </section>

        <section className="block" id="recognition">
          <p className="block-label label">06 — Achievements</p>
          <ul className="awards reveal">
            {awards.map((a) => (
              <li className="award" key={a.t}><span className="t">{a.t}</span><span className="y">{a.y}</span></li>
            ))}
          </ul>
        </section>

        <section className="closing">
          <div style={{ paddingInline: 'clamp(20px,4vw,44px)' }}>
            <p className="block-label label">Let's connect</p>
            <p className="lead">Building the future of AI, enterprise tech and B2B.</p>
            <div className="linkline">
              <a className="link-cta" href="mailto:akshay.0015@gmail.com">Get in Touch</a>
              <a className="link-cta" href="https://www.linkedin.com/in/akshay7hegde/" target="_blank" rel="noreferrer">View LinkedIn</a>
            </div>
            <small>© {year} Akshay Hegde. All rights reserved.</small>
          </div>
        </section>

      </main>
    </div>
  );
}

export default App;
